import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import * as Loadings from '../../../constants/loadings/user';
import { addUserService } from '../../../actions/user-api';
import { ServicesEdit } from './../_common/servicesEdit';
import { AssuranceOptions, SocialNetworksOptions, PersonalServices, OtherService, ConnectionTypes } from '../../../constants/utils/connectionTypes';
import { ServiceCard } from './serviceCard';
import { getProgress } from '../../anticipa/_common/serviceNavbar/calculateProgress';
import { LoadingState } from '../../../_common/loadingState';

export const Personal = ({ isDemo }) => {
    const dispatch = useDispatch();
    const [selectedService, setSelectedService] = useState(undefined);
    const user = useSelector(state => state.user);
    const servicesData = useSelector(state => state.services);
    const [selectedServices, setSelectedServices] = useState([]);

    function isInsurance(str) {
        if (str === ConnectionTypes.voitureAssurance || str === ConnectionTypes.bateau || str === ConnectionTypes.moto || str === ConnectionTypes.scooter) {
            return true;
        }
        return false;
    }

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user) && !R.isNil(user.services) && !R.isEmpty(user.services)) {
            setSelectedServices(user.services);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user.services) && user.services.length > 0) {
            setSelectedServices(user.services);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.services]);

    function AddOrRemove(option) {
        if (isDemo) return;
        let tmpSelected = JSON.parse(JSON.stringify(selectedServices));
        if (tmpSelected.findIndex(o => o.connectionType === option.connectionType) === -1) {
            tmpSelected.push(option);
            dispatch(addUserService(user.user, { connectionType: option.connectionType }));
        }
        setSelectedServices(tmpSelected);
    }

    if (user.isLoading.includes(Loadings.FETCH_SERVICES)) {
        return <LoadingState />;
    }
    $('[data-toggle="tooltip"]').tooltip();

    return (
			<article className="view-calc my-4">
				{/* <div className="auto-view py-3 pb-lg-0"> */}
				<div className="container-fluid">
					<section className="block">
						<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">Vie quotidienne à sélectionner : </h4>
						<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
							{R.sortWith([R.ascend(R.prop("title"))])(Object.values(PersonalServices)).map((srv, index) => {
								let progress = getProgress(servicesData.serviceData, srv.connectionType);
								return <ServiceCard key={"personal" + index} selectedServices={selectedServices} service={srv} progress={progress} addOrRemove={AddOrRemove} setSelectedService={setSelectedService} isDemo={isDemo} />;
							})}
							{Object.values(OtherService)
								.filter(
									(o) =>
										o.connectionType !== ConnectionTypes.activity && o.connectionType !== ConnectionTypes.pension && o.connectionType !== ConnectionTypes.otherActivity && o.connectionType !== ConnectionTypes.poleEmploi && o.connectionType !== ConnectionTypes.locataire && o.connectionType !== ConnectionTypes.etudiant
								)
								.map((srv, index) => {
									let progress = getProgress(servicesData.serviceData, srv.connectionType);
									return <ServiceCard key={"other" + index} selectedServices={selectedServices} service={srv} progress={progress} addOrRemove={AddOrRemove} setSelectedService={setSelectedService} isDemo={isDemo} />;
								})}
						</form>
					</section>
					<section className="block mt-5 pt-2">
						<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">SITUATION PROFESSIONNELLE ( à sélectionner) </h4>
						<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
							{Object.values(OtherService)
								.filter((o) => o.connectionType !== ConnectionTypes.other && o.connectionType !== ConnectionTypes.locataire)
								.map((srv, index) => {
									let progress = getProgress(servicesData.serviceData, srv.connectionType);
									return <ServiceCard key={"other" + index} selectedServices={selectedServices} service={srv} progress={progress} addOrRemove={AddOrRemove} setSelectedService={setSelectedService} isDemo={isDemo} />;
								})}
						</form>
					</section>
					<section className="block mt-5 pt-2">
						<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">RÉSEAUX SOCIAUX ( à sélectionner) </h4>
						<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
							{R.sortWith([R.ascend(R.prop("title"))])(Object.values(SocialNetworksOptions)).map((srv, index) => {
								let progress = 0;
								if (!R.isNil(servicesData.serviceData[ConnectionTypes.socialNetworks]) && selectedServices.findIndex((s) => s.connectionType === srv.connectionType) !== -1) {
									progress = getProgress(servicesData.serviceData, ConnectionTypes.socialNetworks);
								}

								return <ServiceCard key={"social" + index} selectedServices={selectedServices} service={srv} progress={progress} addOrRemove={AddOrRemove} setSelectedService={setSelectedService} isSocialNetwork={true} isDemo={isDemo} />;
							})}
						</form>
					</section>
					<section className="block mt-5 pt-2">
						<h4 className="h6 lh-copy text-uppercase font-weight-bolder mt-2 mb-1">ASSURANCE ( à selectionner) </h4>
						<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
							{R.sortWith([R.ascend(R.prop("title"))])(Object.values(AssuranceOptions)).map((srv, index) => {
								let progress = getProgress(servicesData.serviceData, srv.connectionType);
								return <ServiceCard key={"insurance" + index} selectedServices={selectedServices} service={srv} progress={progress} addOrRemove={AddOrRemove} setSelectedService={setSelectedService} isDemo={isDemo} />;
								// let progress = 0;
								// if (!R.isNil(servicesData.serviceData[isInsurance(srv.connectionType) ? ConnectionTypes.insurance : srv.connectionType]) && selectedServices.findIndex(s => s.connectionType === srv.connectionType) !== -1) {
								//     progress = getProgress(servicesData.serviceData, ConnectionTypes.insurance);
								// }
							})}
						</form>
					</section>
				</div>
				{/* </div> */}
				<ServicesEdit selectedService={selectedService} setSelectedService={setSelectedService} />
			</article>
		);
}